import React from 'react';
import ProfileLayout from 'src/app/layouts/ProfileLayout';
import { ShimmerThumbnail } from "react-shimmer-effects";

const MedicineFormLoader = () => {
  return (
    <ProfileLayout title={"Medicine Form"}>
      <div className="d-flex align-items-center justify-content-center">
        <div style={{ width: '150px' }}><ShimmerThumbnail height={10} className="rounded-5 mb-0" /></div>
      </div>
      <div className="mx-n-20 pd-x-20 pd-b-15 border-bottom border-gray border-b-w-6">
        <div className="mg-t-30">
          <div style={{ width: '170px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '140px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className="mg-t-30">
          <div style={{ width: '115px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '130px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className="mg-t-30">
          <div style={{ width: '112px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '90px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className="mg-t-30">
          <div style={{ width: '130px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '90px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
      </div>
      <div className="mx-n-20 pd-x-20 pd-b-15 border-bottom border-gray border-b-w-6">
        <div className="mg-t-30">
          <div style={{ width: '80%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '65px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className="mg-t-30">
          <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '65px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className="mg-t-30">
          <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '65px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className="d-flex mg-t-20">
          <div style={{ width: '64px' }}><ShimmerThumbnail height={64} className="rounded-3 mb-0" /></div>
          <div style={{ width: '64px' }} className="mg-l-10"><ShimmerThumbnail height={64} className="rounded-3 mb-0" /></div>
        </div>
      </div>
      <div className="mx-n-20 pd-x-20 pd-b-15 pd-t-15 border-bottom border-gray border-b-w-6">
        <div style={{ width: '80%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '80%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
      </div>
      <div className="mx-n-20 pd-x-20 pd-b-15 pd-t-15 border-bottom border-gray border-b-w-6">
        <div style={{ width: '100%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '50%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        <div style={{ width: '65px' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
      </div>
      <div className='pd-t-15'>
        <div>
          <div style={{ width: '140px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '80%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className='mg-t-20'>
          <div style={{ width: '140px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '80%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className='mg-t-20'>
          <div style={{ width: '140px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-5"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '80%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div className='mg-t-20'>
          <div style={{ width: '100px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div className="d-flex mg-t-10 overflow-hidden">
          {
            Array.from({ length: 8 }).map((_, index) => {
              return (
                <div style={{ width: '130px', minWidth: '130px' }} className={`${index === 7 ? '' : 'mg-r-10'}`}><ShimmerThumbnail height={130} className="rounded-3 mb-0" /></div>
              );
            })
          }
            {/* <div style={{ width: '130px' }}><ShimmerThumbnail height={130} className="rounded-3 mb-0" /></div> */}
            
          </div>
        </div>
      </div>
    </ProfileLayout>
  );
};

export default MedicineFormLoader;